import { render, staticRenderFns } from "./LoginAntiguos.vue?vue&type=template&id=3638bc7b&scoped=true"
import script from "./LoginAntiguos.vue?vue&type=script&lang=ts"
export * from "./LoginAntiguos.vue?vue&type=script&lang=ts"
import style0 from "./LoginAntiguos.vue?vue&type=style&index=0&id=3638bc7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3638bc7b",
  null
  
)

export default component.exports